export default __webpack_public_path__ + "594aa4172e858e9ac502dd3066420793.woff2";